import axiosInstance from '../../../axiosInstance'
import apiEndpoints from '../../../api'


export const getInvoiceSettingsReq = (action) => {
    const params = action?.data || {};
    return axiosInstance.get(apiEndpoints.GET_INVOICE_SETTINGS_API, { params })
}

export const updateInvoiceSettingsReq = (action) => {
    const payload = action?.data || {}
    // const config = {
    //     params: {
    //         society_id: payload.society_id,
    //         invoice_type_id: payload.invoice_type_id,
    //     }
    // }
    // Remove society_id, invoice_type_id, and onSuccess from payload as they are not part of the body
    const body = { ...payload };
    // delete body.society_id;
    // delete body.invoice_type_id;
    delete body.onSuccess;

    return axiosInstance.put(apiEndpoints.UPDATE_INVOICE_SETTINGS_API, body)
}
